import React, { useCallback, useEffect, useRef, useState } from "react";
import { postCommentRepliesPath } from "../../../../routes";
import { SharedApprovedCurrentUser } from "../../shared/lib/types";
import useRequest from "../../shared/lib/useRequest";
import {
  PostComment,
  PostCommentRepliesIndex,
  PostsShowProps,
  UserPostCommentReply,
} from "../lib/types";
import Reply from "./Reply";

import { Box } from "../../shared/components/ui/chakra";
import { Divider, Spinner, Stack } from "@chakra-ui/react";

const Replies = ({
  comment,
  currentUser,
  onFetched,
  isFocusEndOfReplies,
  post,
}: {
  comment: PostComment;
  currentUser: SharedApprovedCurrentUser;
  onFetched: (result: PostCommentRepliesIndex) => void;
  isFocusEndOfReplies: boolean;
  post: PostsShowProps;
}) => {
  const [replies, setReplies] = useState<UserPostCommentReply[]>();
  const endOfRepliesRef = useRef<HTMLDivElement>(null);
  const request = useRequest();

  const fetchReplies = useCallback(
    async (comment_code: string) => {
      const res = await request(postCommentRepliesPath(comment_code), "GET");
      const result = await res.json() as PostCommentRepliesIndex;
      setReplies(result.replies);
      onFetched(result);
    },
    [request, onFetched],
  );

  useEffect(() => {
    void fetchReplies(comment.code);
  }, [fetchReplies, comment.code]);

  useEffect(() => {
    if (isFocusEndOfReplies) {
      // すぐ遷移しようとすると途中で止まるので一瞬待つ
      setTimeout(() => {
        endOfRepliesRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }, 250);
    }
  }, [isFocusEndOfReplies]);

  return (
    <>
      <Stack mt={2} gap={3}>
        {!replies ? (
          <Box textAlign="center">
            <Spinner />
          </Box>
        ) : (
          <Stack>
            {/* 最初の一件はすでに表示済みなので除外 */}
            {[...replies]
              .reverse()
              .slice(1)
              .map((reply, i) => (
                <Box mt={6} key={reply.code}>
                  <Reply
                    reply={reply}
                    currentUser={currentUser}
                    post={post}
                    key={reply.code}
                  />
                  {/* 2の理由は最初の一件が除外されているため */}
                  {i !== replies.length - 2 && (
                    <Divider
                      borderStyle="dashed"
                      borderColor="primary"
                      borderBottomWidth="0.5px"
                      mt={6}
                    />
                  )}
                </Box>
              ))}
          </Stack>
        )}
        <div ref={endOfRepliesRef} />
      </Stack>
    </>
  );
};
export default Replies;
